import { useState, useEffect } from 'react';
import GlobalSettingAPI from "restAPI/GlobalSettingAPI";

export const useFetchProductStatus = () => {
    const [statusList, setStatusList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        const { promise, cancel } = GlobalSettingAPI.getCustomizedStatus();
        promise
            .then(setStatusList)
            .catch(console.log)
            .finally(() => setLoading(false));
        return cancel;
    }, []);

    return { loading, statusList }
}